import axios from 'axios'
import { Notification, Message, Loading } from 'element-ui'
import cache from './cache'
import { HTTP_URI } from '../api/api'
const Base64 = require('js-base64').Base64


// if (window.localStorage.getItem('user')) {
//   var token = JSON.parse(window.localStorage.getItem('user')).token
// }

let loading
// loading开始 方法
function startLoading() {
  // element-ui loading 服务调用方式
  // loading = Loading.service({
  //   customClass: 'loading_icon',
  //   fullscreen: true,
  //   lock: true,
  //   text: 'Loading...',
  //   spinner: 'el-icon-loading', // 自定义图标
  //   background: 'rgba(255, 255, 255, 0.1)',

  // })
}
// loading结束 方法
function endLoading() {
  loading.close()
}

// 定义一个变量，有请求变量加一，收到响应变量减一
let loadingCount = 0
/**
 * 调用一次startLoadingAddCount() 方法 开启Loading 并 loadingCount + 1
 * 调用一次endLoadingSubCount() 方法 loadingCount - 1 直到为0 关闭loading
 */
export function startLoadingAddCount() {
  if (loadingCount === 0) {
    // startLoading()
  }
  loadingCount++
}

export function endLoadingSubCount() {
  loadingCount--
  if (loadingCount === 0) {
    // endLoading()
  }
}
axios.defaults.withCredentials = true
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: HTTP_URI.BASEURL,
  // 超时
  timeout: 30000
})

// request拦截器
service.interceptors.request.use(
  config => {
    startLoadingAddCount()

    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false

    const localUser = localStorage.getItem('thesis-token');
    let token = ''
    if(localUser){
      const localToken = Base64.decode(localUser).split('----');
      // console.log(localToken)
      token = localToken[1].replace(/\d{4}$/, '');
      // console.log(token)
      // console.log( localToken[1])
    }
    if (token && !isToken) {
      config.headers['token'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    //
    if (!isRepeatSubmit && config.method === 'post') {
      const datas = config.data
      const data = Object.keys(datas).map(item => {
        if (datas[item] === '' || datas[item] == null) delete datas[item]
      })
      const requestObj = {
        url: config.url,
        data: data,
        time: new Date().getTime()
      }
      const sessionObj = cache.session.getJSON('sessionObj')
      if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
    return config
  },
  error => {
    endLoadingSubCount()
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  res => {
    endLoadingSubCount()
    // console.log(res)
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = res.data.messageEn || res.data.msgEn || res.data.message
    if (code === 200 || code === 0 ) {
      return res.data
      
    } else if (code === 2002) {
      Notification.error({
        title: msg,
      })
      localStorage.removeItem('thesis-token');
      localStorage.removeItem('userInfo');
      // window.localStorage.clear()
      setTimeout(() => {
        window.location.href = `/`
      }, 1000)
    } else {
      Notification.error({
        title: msg
      })
      return Promise.reject('error')
    }
  },
  error => {
    endLoadingSubCount()
    let { message } = error
    if (message === 'Network Error') {
      // message = '网络连接错误'
      message = 'Network Error'
    } else if (message.includes('timeout')) {
      // message = '系统接口请求超时'
      message = 'Request Timeout'
    } else if (message.includes('Request failed with status code')) {
      // message = '系统接口' + message.substr(message.length - 3) + '异常'
      message = 'System interface' + message.substr(message.length - 3) + 'exceptions'
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export default service
